import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  sidebarOpen: boolean;
  env: 'prod' | 'dev' | 'staging';
  darkMode: boolean;
  toggleSidebar: () => void;
  setSidebar: (open: boolean) => void;
  setEnv: (env: UiState['env']) => void;
  toggleDarkMode: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      env: (import.meta.env.VITE_ENV as UiState['env']) ?? 'dev',
      darkMode: false,
      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      setSidebar: (open) => set({ sidebarOpen: open }),
      setEnv: (env) => set({ env }),
      toggleDarkMode: () =>
        set((s) => {
          const next = !s.darkMode;
          document.documentElement.classList.toggle('dark', next);
          return { darkMode: next };
        }),
    }),
    {
      name: 'dispatcher.ui',
      partialize: (s) => ({ darkMode: s.darkMode }),
      onRehydrateStorage: () => (state) => {
        if (state?.darkMode) document.documentElement.classList.add('dark');
      },
    },
  ),
);
